import { siteService } from "../../../services/SiteService";

export default {
    name: "DownloadPolicy",
    props: {
        order: {}
    },
    data() {
        return {
            downloadLink: '',
            responseBT: null,
            loading: true,
            issuePolicyError: false,
        }
    },
    computed: {

    },
    created() {
        //http://localhost:8090/#/order/44151/download?orderId=99ad1c35-1fdd-490f-8677-5ad809b9e576&token=fXJLfvJr1Y0FtwuWjbJFdzdFCxcqaMZqlWsk%2BNms5NQmDsy5yXG8FD7cdXH3cfsTc5Kwjqp81cqBykRN5jtWNA%3D%3D&approvalCode=404279&refNum=002324404279&language=ro
        this.responseBT = {
            OrderId: this.orderId = parseInt(this.$route.params.id),
            BTOrderId: this.$route.query.orderId,
            BTRefNum: this.$route.query.refNum,
            BTapprovalCode: this.$route.query.approvalCode,
        }

        var model = this;
        model.loading = true;
        siteService.issuePolicy(this.responseBT).then((response) => {
            model.downloadLink = response.data;
            model.loading = false;
        })
        .catch((error) => {
            model.issuePolicyError = true;
        })
        .finally(() => {
            model.loading = false;
        })

    },
    methods: {
        download: function () {
            var win = window.open(this.downloadLink, '_blank');
            win.focus();
        }
    }
};
